import { render, staticRenderFns } from "./GetaoCompraPrevisaoEntregaEdit.vue?vue&type=template&id=6c09cc6b&"
import script from "./GetaoCompraPrevisaoEntregaEdit.vue?vue&type=script&lang=js&"
export * from "./GetaoCompraPrevisaoEntregaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VEditDialog,VIcon,VTooltip})
